"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerResources = void 0;
const vue_1 = require("vue");
const CardName_1 = require("../../CardName");
const PlayerResource_1 = require("./PlayerResource");
const Resources_1 = require("../../Resources");
exports.PlayerResources = vue_1.default.component('player-resources', {
    props: {
        player: {
            type: Object,
        },
    },
    data: function () {
        return {
            resources: Resources_1.Resources,
        };
    },
    methods: {
        canUseHeatAsMegaCredits: function () {
            return this.player.corporationCards.some((corp) => corp.name === CardName_1.CardName.HELION);
        },
    },
    components: {
        'player-resource': PlayerResource_1.PlayerResource,
    },
    template: `
        <div class="resource_items_cont">
            <player-resource :type="resources.MEGACREDITS" :count="player.megaCredits" :production="player.megaCreditProduction"></player-resource>
            <player-resource :type="resources.STEEL" :count="player.steel" :production="player.steelProduction" :steelValue="player.steelValue" :turmoil="player.turmoil"></player-resource>
            <player-resource :type="resources.TITANIUM" :count="player.titanium" :production="player.titaniumProduction" :titaniumValue="player.titaniumValue" :turmoil="player.turmoil" :corporationCards="player.corporationCards"></player-resource>
            <player-resource :type="resources.PLANTS" :count="player.plants" :production="player.plantProduction" :plantsAreProtected="player.plantsAreProtected" :plantsNeededForGreenery="player.plantsNeededForGreenery"></player-resource>
            <player-resource :type="resources.ENERGY" :count="player.energy" :production="player.energyProduction"></player-resource>
            <player-resource :type="resources.HEAT" :count="player.heat" :production="player.heatProduction" :canUseHeatAsMegaCredits="canUseHeatAsMegaCredits()" :corporationCards="player.corporationCards"></player-resource>
        </div>
    `,
});
//# sourceMappingURL=PlayerResources.js.map